import React, { useState } from "react";
import { ExclamationTriangleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
function NotFitPopup(props) {
    const { onClose, onSend } = props;
    const [value, setValue] = useState('');
    const handleSend = () => {
        if (typeof onSend === "function") {
            onSend(value);
        }
    };
    return (
        // Your alert popup component JSX
        <div className="bg-white rounded-lg shadow lg:w-[480px] outline-none focus:rounded-lg focus:outline-none focus:ring-main-violate  h-[480px] py-2 flex flex-col px-4 py-4">
            <div className="flex justify-end">
                <button
                    className="text-gray-500 hover:text-gray-700 transition-colors duration-200 focus:outline-none"
                    onClick={() => {
                        onClose()
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div className="flex flex-col items-center justify-evenly h-full w-full" >
                <div className="text px-2">
                    <p className="font-bold text-center text-lg mb-3">
                    Not Fit
                    </p>
                    <p className="text-center text-base text-gray-500">
                    Your candidate does not meet the qualifications.
                    </p>
                </div>
                <div className="h-[200px] mb-4 w-full">
                    <ReactQuill theme="snow" value={value} onChange={setValue} className="h-full w-full" />
                </div>
                <div className="flex mt-5 justify-end w-[100%] gap-4">
                    <button
                        className="hover:bg-violet-600 cursor-pointer bg-main-violate  px-4 py-2 text-[16px] leading-[22.4px] text-white font-semibold tracking-normal h-[46px] rounded-lg disabled:bg-violet-300 disabled:cursor-not-allowed"
                        onClick={(e) => handleSend()}
                    >
                        Send Message
                    </button>
                </div>
            </div>
        </div>

    );
}

export default NotFitPopup;
